import * as localForageLib from 'localforage';

// TODO: Delete once typings are exported: https://github.com/localForage/localForage/pull/767
export interface MobizLocalForage {
  getItem<T>(key: string, callback?: (err: any, value: T | null) => void): Promise<T | null>;
  setItem<T>(key: string, value: T, callback?: (err: any, value: T) => void): Promise<T>;
  removeItem(key: string, callback?: (err: any) => void): Promise<void>;
  clear(callback?: (err: any) => void): Promise<void>;
  length(callback?: (err: any, numberOfKeys: number) => void): Promise<number>;
  key(keyIndex: number, callback?: (err: any, key: string) => void): Promise<string>;
  keys(callback?: (err: any, keys: string[]) => void): Promise<string[]>;
  iterate<T, U>(iteratee: (value: T, key: string, iterationNumber: number) => U,
          callback?: (err: any, result: U) => void): Promise<U>;
}
export type MobizLocalForageOptions = any;

export class MobizLocalForageDrivers {
  public static readonly LOCALSTORAGE = localForageLib.LOCALSTORAGE;
  public static readonly WEBSQL = localForageLib.WEBSQL;
  public static readonly INDEXEDDB = localForageLib.INDEXEDDB;
}

export function mobizCreateLocalForageInstance(config: MobizLocalForageOptions): MobizLocalForage {
  return localForageLib.createInstance(config);
}
